type SectionHeadingProps = {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  actionLabel?: string;
  actionTo?: string;
  actionIcon?: string;
};

import { Link } from "react-router-dom";

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
  actionLabel,
  actionTo,
  actionIcon = "ri-arrow-right-line",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        {kicker && (
          <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.25em] text-primary-600 uppercase">
            <span className="w-6 h-px bg-primary-500"></span>
            {kicker}
          </span>
        )}
        <h2 className="mt-3 font-heading font-bold text-2xl md:text-[32px] leading-tight text-foreground-950">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 font-label text-sm md:text-[15px] leading-relaxed text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex items-center gap-2 shrink-0 font-label text-sm text-foreground-800 hover:text-primary-600 transition-colors cursor-pointer"
        >
          {actionLabel}
          <i className={`${actionIcon} transition-transform group-hover:translate-x-1`}></i>
        </Link>
      )}
    </div>
  );
}